import React from "react";

import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Popover, PopoverProps, Typography } from "@mui/material";

import "./BenchmarkHintPopover.styles.scss";

const BenchmarkHintPopover = (props: PopoverProps) => {
  return (
    <Popover
      {...props}
      classes={{ paper: "benchmark-hint-popover" }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <div className="benchmark-hint-popover__title">
        <Typography sx={{ fontWeight: 700 }} variant="body1">
          Market Benchmark Report
        </Typography>
        <CloseOutlined onClick={(e) => props.onClose?.(e, "backdropClick")} />
      </div>
      <p>
        Altius scans 2,500+ assets managed on the platform and anonymizes, standardizes, normalizes, and categorizes the
        data. The platform then estimates IRR, DPI (Distributions to Paid-In), and MOIC across asset classes and vintage
        years in real time.
      </p>
      <br />
      <p>
        Altius has validated benchmark results by comparing them to publicly available performance data from asset
        managers.
      </p>
    </Popover>
  );
};

export default BenchmarkHintPopover;
